import logo from "@/assets/pacazur-logo.png";

const PALETTE = ["#007AFF", "#E4022D", "#10B981", "#F59E0B", "#8B5CF6", "#0EA5E9", "#EC4899"];
const initials = (n) => (n || "?").split(/[\s\-_']+/).filter((w) => /[A-Za-zÀ-ÿ0-9]/.test(w)).slice(0, 2).map((w) => w[0].toUpperCase()).join("") || "?";
const colorOf = (n) => PALETTE[[...(n || "")].reduce((s, c) => s + c.charCodeAt(0), 0) % PALETTE.length];

export function SpaceBrand({ user, compact = false }) {
  const sp = user?.space;
  const isDefault = !sp || sp.is_default;
  const name = isDefault ? (sp?.custom_name ? sp.nav_name : "PACAZUR-KEYS") : sp.nav_name;
  const size = compact ? "w-8 h-8 text-xs" : "w-9 h-9 text-sm";
  return (
    <div className="flex items-center gap-2.5 min-w-0" data-testid="nav-brand">
      {isDefault ? (
        <img src={logo} alt="PACAZUR" className={`${compact ? "w-8 h-8" : "w-9 h-9"} object-contain shrink-0`} data-testid="nav-brand-logo" />
      ) : (
        <span data-testid="nav-brand-initials" className={`${size} shrink-0 rounded-md flex items-center justify-center font-display font-bold`}
          style={{ backgroundColor: colorOf(name), color: "#FFFFFF" }}>{initials(name)}</span>
      )}
      <span data-testid="nav-brand-name" title={name} className={`font-display font-semibold tracking-tight leading-tight line-clamp-2 break-words ${compact || name.length > 14 ? "text-sm" : ""}`}>{name}</span>
    </div>
  );
}
